import firebase from "firebase/app";
import "firebase/auth";

import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";

import "@/firebase";
import { db, usersCollection } from "@/firebase";
import GlobalRules from "./rules";
import Questionnaire from "./Questionnaire";

import VueRecaptcha from "vue-recaptcha";
import RecaptchaContainer from "@/components/Recaptcha.vue";

enum SIGNUP_STATE {
  PERSONAL_INFO,
  QUESTIONNAIRE
}

@Component({
  components: { VueRecaptcha }
})
export default class SignUp extends Vue {
  private rules = GlobalRules;
  private state: SIGNUP_STATE = SIGNUP_STATE.PERSONAL_INFO;
  private gender = ["Female", "Male", "Other"];
  private _schoolList: string[] = [];
  private _teacherList: any = [];
  private _schoolAndTeachers: any;
  private grades = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  private input_info: any = {};
  private teacherNameEnable = false;

  private _inputValid: boolean = false;
  private emailExists: boolean = false;
  private passwordRule!: any;

  private recaptcha: boolean = false;

  created() {
    window.scrollTo(0, 0);
    this.passwordRule = Array.from(this.rules.password);
    this.passwordRule.push(
      () =>
        this.input_info["password"] == this.input_info["confirm_password"] ||
        "No you"
    );
  }

  mounted() {
    this.teacherNameEnable = false;
    this._schoolAndTeachers = {};
    this._schoolList = [];
    this._teacherList = [];
    usersCollection
      .where("accountType", "==", "teacher")
      .get()
      .then(async (snapshot: any) => {
        await snapshot.forEach((doc: any) => {
          let data: any = doc.data();
          if (this._schoolAndTeachers[data["schoolname"]]) {
            this._schoolAndTeachers[data["schoolname"]].push(doc);
          } else {
            this._schoolAndTeachers[data["schoolname"]] = [doc];
            this._schoolList.push(data["schoolname"]);
          }
        });
      })
      .finally(() => {
        this._schoolList.push("Not Affiliated with a school");
        this.$forceUpdate();
      });
  }

  render(h: CreateElement) {
    return (
      <div>
        {this.studentInfo()}
        {this.state === SIGNUP_STATE.QUESTIONNAIRE && (
          <Questionnaire
            callbackOnComplete={this.questionnaireCompleted}
            backToStudentInfo={this.backToHere.bind(this)}
          />
        )}
      </div>
    );
  }

  private backToHere() {
    this.state = SIGNUP_STATE.PERSONAL_INFO;
    this.$forceUpdate();
  }

  private studentInfo() {
    return (
      this.state == SIGNUP_STATE.PERSONAL_INFO && (
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="accent" dark flat>
                <v-toolbar-title>
                  Student registration for BalanceAI
                </v-toolbar-title>
              </v-toolbar>
              <v-form ref="form" v-model={this._inputValid}>
                <v-card-text>
                  {/* <v-label>
                    If you agree to participate in the study, please check the
                    following button.
                  </v-label>
                  <v-radio-group
                    v-model={this.input_info["consent"]}
                    rules={this.rules.radio}
                    required
                    row
                  >
                    <v-radio
                      key={"yes"}
                      label={"Agree"}
                      value={"yes"}
                    ></v-radio>
                    <v-radio
                      key={"no"}
                      label={"Disagree"}
                      value={"no"}
                    ></v-radio>
                  </v-radio-group> */}

                  <v-text-field
                    label="E-mail"
                    name="email"
                    rules={this.rules.email}
                    v-model={this.input_info["email"]}
                    required
                    autocomplete="email"
                    error-messages={
                      this.emailExists ? "Please use a different email." : ""
                    }
                  ></v-text-field>
                  <v-text-field
                    no-filter
                    id="password"
                    label="Password"
                    name="password"
                    rules={this.rules.password}
                    v-model={this.input_info["password"]}
                    // type="text"
                    required
                    counter="20"
                  ></v-text-field>
                  <v-text-field
                    no-filter
                    id="confirm_password"
                    label="Confirm Password"
                    name="confirm_password"
                    rules={this.passwordRule}
                    v-model={this.input_info["confirm_password"]}
                    // type="password"
                    required
                    counter="20"
                  ></v-text-field>

                  <v-text-field
                    name="firstname"
                    rules={this.rules.nameRules}
                    type="text"
                    v-model={this.input_info["firstname"]}
                    required
                    autocomplete
                    label="First Name"
                  ></v-text-field>
                  <v-text-field
                    name="lastname"
                    rules={this.rules.nameRules}
                    type="text"
                    v-model={this.input_info["lastname"]}
                    required
                    autocomplete
                    label="Last Name"
                  ></v-text-field>
                  <v-select
                    label="Gender"
                    name="gender"
                    v-model={this.input_info["gender"]}
                    items={this.gender}
                    required
                  ></v-select>
                  <v-text-field
                    id="birthdate"
                    label="Birth Date"
                    name="birthdate"
                    rules={this.rules.dateRules}
                    hint="YYYY-MM-DD"
                    v-model={this.input_info["birthdate"]}
                    type="text"
                    required
                    autocomplete
                  ></v-text-field>
                  <v-select
                    label="Grade"
                    name="grade"
                    v-model={this.input_info["grade"]}
                    items={this.grades}
                    required
                  ></v-select>
                  <v-autocomplete
                    name="schoolname"
                    hide-no-data
                    v-model={this.input_info["schoolname"]}
                    items={this._schoolList}
                    item-text={this._schoolList}
                    required
                    prepend-icon="mdi-magnify"
                    onchange={() => {
                      this.input_info["teachername"] = null;
                      this.teacherNameEnable =
                        this.input_info["schoolname"] !=
                        this._schoolList[this._schoolList.length - 1];
                      this._teacherList = [];
                      if (!this.teacherNameEnable) return;
                      for (let doc of this._schoolAndTeachers[
                        this.input_info["schoolname"]
                      ]) {
                        let data = (doc as any).data();
                        this._teacherList.push({
                          name: data["firstname"] + " " + data["lastname"],
                          id: doc.id
                        });
                      }
                      this.$forceUpdate();
                    }}
                    placeholder="Start typing to search"
                    label="School Name"
                    rules={this.rules.required}
                  ></v-autocomplete>
                  <v-autocomplete
                    name="teachername"
                    disabled={!this.teacherNameEnable}
                    prepend-icon="mdi-magnify"
                    hide-no-data
                    items={this._teacherList}
                    item-text={"name"}
                    v-model={this.input_info["teachername"]}
                    autocomplete
                    label="Teacher Name"
                    return-object
                  ></v-autocomplete>
                  <v-container style={{ padding: 20 }}>
                    <v-row justify="center" style={{ marginBottom: "15px" }}>
                      <RecaptchaContainer
                        site_key={process.env.VUE_APP_RECAPTCHA_SITE_KEY}
                        secret={process.env.VUE_APP_RECAPTCHA_SECRET_KEY}
                        verify={this.recaptcha_handler}
                        error={this.recaptcha_handler}
                        expire={this.recaptcha_handler}
                      />
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn
                  disabled={!this._formComplete()}
                  color="accent"
                  onclick={this._proceedToQuestionnaire}
                >
                  Continue To Questionnaire
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      )
    );
  }

  private recaptcha_handler(res?: any) {
    this.recaptcha = res ? true : false;
    this.$forceUpdate();
  }

  private _formComplete() {
    let form = this.$refs.form as any;
    let teacher = this.teacherNameEnable
      ? this.teacherNameEnable && this.input_info["teachername"]
      : true;
    return form && form.validate() && teacher && this.recaptcha;
  }

  private questionnaireCompleted(callback: any) {
    firebase
      .auth()
      .createUserWithEmailAndPassword(
        this.input_info.email,
        this.input_info.password
      )
      .then(data => {
        this.$store.subscribe((mutation: any, state: any) => {
          if (mutation.type == "SET_LOGGED_IN" && mutation.payload) {
            callback();
            this._submitPersonalInfo();
            this.$store.dispatch("addNotification", {
              type: "success",
              value: "Creating your account was successful",
              timeout: 4000,
              icon: "mdi-account"
            });
          }
        });
        // create student info and questionnaire
      })
      .catch(err => {
        this.$store.dispatch("addNotification", {
          type: "error",
          value: "Something went wrong. Please try again",
          timeout: 5000,
          icon: "mdi-account"
        });
      });
  }

  private _proceedToQuestionnaire() {
    if (!this._formComplete()) {
      return;
    }

    firebase
      .auth()
      .fetchSignInMethodsForEmail(this.input_info["email"])
      .then((e: string[]) => {
        if (!(e && e[0] === "password")) {
          this.emailExists = false;
          this.state = SIGNUP_STATE.QUESTIONNAIRE;
        } else {
          this.emailExists = true;
          this.$store.dispatch("addNotification", {
            type: "error",
            value: "This email cannot be used. Please use a different email",
            timeout: 3000,
            icon: "mdi-email"
          });
        }
        this.$forceUpdate();
      })
      .catch((e: any) => {
        this.$store.dispatch("addNotification", {
          type: "error",
          value: "Something went wrong. Please try again.",
          timeout: 5000,
          icon: "mdi-account"
        });
      });
  }

  private _submitPersonalInfo() {
    let currentUser = firebase.auth().currentUser;

    if (currentUser != null) {
      usersCollection
        .doc(currentUser.uid)
        .set({
          firstname: this.input_info.firstname,
          lastname: this.input_info.lastname,
          gender: this.input_info.gender,
          grade: this.input_info.grade,
          birthdate: this.input_info.birthdate,
          accountType: "student",
          schoolname: this.input_info.schoolname,
          teachername: this.input_info.teachername
            ? this.input_info.teachername.name
            : null,
          teacherid: this.input_info.teachername
            ? this.input_info.teachername.id
            : null,
          dateSubmitted: Date.now()
          // consent_signup: this.input_info.consent
        })
        .then(() => {
          this.$store.dispatch("addNotification", {
            type: "success",
            value: "Student information stored successfully",
            timeout: 4000,
            icon: "mdi-account"
          });
        })
        .catch(err => {
          this.$store.dispatch("addNotification", {
            type: "error",
            value:
              "Failed to store student information. Please contact an administrator.",
            timeout: 5000,
            icon: "mdi-account"
          });
        });
    }
  }
}

const component = SignUp;
